const uses = {
  eyebrow: 'Guía de grados',
  title: 'Qué canela para cada uso',
  intro: 'La mayoría de quienes nos escriben saben qué quieren elaborar, pero no qué grado necesitan. Esta página relaciona ambas cosas, y además explica cómo almacenarla, cómo cocinar con ella y qué enviarnos cuando quiera una cotización.',

  guide: {
    eyebrow: 'Guía rápida',
    title: 'Empiece por lo que va a elaborar',
    tableLabel: 'Grados recomendados según el uso',
    columns: ['Si va a elaborar…', 'Le sugerimos', 'Por qué'],
    rows: [
      { use: 'Rama entera para menudeo, regalos y cafeterías', grades: ['C5', 'C4'], why: 'Las ramas más delgadas y claras que vendemos. Lucen parejas en el anaquel, se parten limpiamente y tienen el sabor más delicado.' },
      { use: 'Té, café, ponche, vino caliente y jarabes', grades: ['C4', 'C5', 'Quillings'], why: 'La rama se infusiona poco a poco y se puede retirar. Si la bebida se cuela de todos modos, los quillings dan el mismo sabor por menos.' },
      { use: 'Canela molida, panadería y mezclas de especias', grades: ['H1', 'H2', 'H3', 'Quillings'], why: 'Una vez molida, nadie ve el tamaño de la rama. Los grados Hamburgo y los quillings invierten su dinero en sabor, no en apariencia.' },
      { use: 'Molienda industrial y extracción', grades: ['Recortes', 'H3', 'Quillings'], why: 'La corteza más económica por kilo. Los trozos varían de tamaño, lo cual no importa si todo va al molino o al destilador.' },
      { use: 'Perfumería, cosméticos y velas', grades: ['Aceite de canela'], why: 'El aceite de hoja y el de corteza huelen muy distinto. Cuéntenos para qué lo usará y le recomendamos el adecuado.' },
    ],
    note: {
      before: 'Los diámetros y fotos de cada grado están en la ',
      link: 'página de productos',
      after: '. ¿No está seguro? Describa lo que va a elaborar y le recomendamos un grado.',
    },
  },

  forms: {
    eyebrow: 'Lo que vendemos',
    title: 'Rama, trozos y aceite',
    caption: 'El extremo de una rama: decenas de capas finas como papel enrolladas juntas.',
    items: [
      { name: 'Rama (quills)', text: 'Corteza interior pelada, enrollada a mano y rellena con trozos más pequeños hasta formar tubos largos. Se clasifica por diámetro: cuanto más delgada la rama, más alto el grado.' },
      { name: 'Quillings', text: 'Trozos de rama de todos los grados. La misma corteza y el mismo sabor, en forma irregular. La opción habitual para moler.' },
      { name: 'Recortes', text: 'Las puntas que quedan al cortar las ramas a su medida. Se venden por peso en cajas de 5 y 10 kg.' },
      { name: 'Canela molida', text: 'Es mejor molerla poco antes de usarla: el aroma se pierde mucho más rápido una vez que la corteza está en polvo.' },
      { name: 'Aceite de hoja y de corteza', text: 'El aceite de hoja es principalmente eugenol, con una calidez parecida al clavo. El de corteza es principalmente cinamaldehído, el aroma clásico de la canela, y cuesta bastante más.' },
    ],
  },

  kitchen: {
    eyebrow: 'En la cocina',
    title: 'Cómo cocinar con canela de Ceilán',
    tips: [
      { title: 'Use un poco más de lo que pide la receta', text: 'La mayoría de las recetas están pensadas para cassia, que es más fuerte. Con canela de Ceilán, empiece con la cantidad indicada y ajuste al gusto.' },
      { title: 'Una rama equivale a media cucharadita', text: 'Un trozo de rama de 7–8 cm da aproximadamente el mismo sabor que ½ cucharadita de canela molida.' },
      { title: 'A fuego lento, sin hervir fuerte', text: 'Para té o leche, deje la rama partida a fuego lento 10–15 minutos. Un hervor largo y fuerte se lleva los aromas más finos.' },
      { title: 'Muélala usted mismo', text: 'Parta las ramas en trozos cortos, páselas por un molino de especias o de café y cierna. El polvo recién molido huele notablemente más dulce.' },
    ],
  },

  storage: {
    eyebrow: 'Almacenamiento',
    title: 'Cómo mantenerla fresca',
    items: [
      'Guárdela en un recipiente hermético, en una alacena fresca y oscura, lejos de la estufa.',
      'La rama entera conserva su sabor de dos a tres años. La canela molida está mejor dentro de los seis meses.',
      'Pruébela partiendo un trozo: la canela buena huele dulce e intensa de inmediato.',
      'En inventario a granel, mantenga las cajas separadas del piso y lejos de paredes húmedas. La humedad es lo que más daña la canela.',
    ],
  },

  faq: {
    eyebrow: 'Preguntas',
    title: 'Lo que más nos preguntan',
    items: [
      { q: '¿La canela que se vende en el supermercado es la misma?', a: 'Muchas veces no. Gran parte de lo que se vende simplemente como “canela” es cassia, una corteza parecida pero distinta. La canela de Ceilán tiene capas finas como papel y un sabor más suave y dulce.', link: { to: '/true-cinnamon', label: 'Cómo distinguirlas' } },
      { q: '¿Por qué la canela de Ceilán tiene un sabor más suave?', a: 'Tiene menos del toque picante y áspero de la cassia, y más notas florales y cítricas. Por eso se puede usar con generosidad en bebidas y postres.' },
      { q: '¿Qué grado compran la mayoría de los fabricantes de alimentos?', a: 'Para todo lo que se muele o se mezcla, grados Hamburgo o quillings. Los grados más altos valen la pena cuando la rama se ve en el producto final.' },
      { q: '¿Puedo ver la canela antes de hacer un pedido completo?', a: 'Sí. Enviamos muestras a solicitud; el envío de muestras se cobra al costo.', link: { to: '/how-we-work', label: 'Cómo funcionan los pedidos' } },
    ],
  },

  quote: {
    eyebrow: 'Pedidos',
    title: 'Qué incluir al pedir una cotización',
    items: [
      'El grado, o el uso que le dará a la canela',
      'La cantidad, y si es un pedido único o recurrente',
      'El empaque: cajas a granel, empaques para menudeo o marca propia',
      'El puerto de destino y las condiciones de envío que prefiera (EXW, FOB, CIF…)',
      'Los documentos que necesite y si desea muestras primero',
    ],
    primary: 'Solicitar cotización',
    secondary: 'Cómo funcionan los pedidos',
  },
};

export default uses;
